import { render } from "./LoginView.vue?vue&type=template&id=5bbe37d3&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=5bbe37d3&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbe37d3"]])

export default __exports__